export enum ESelectionType {
    Union = 0,
    Intersection = 1,
    UserPositions = 2
}

export interface IPositionSelectionSettings {
    Type: ESelectionType
}